



















import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power1,
    Power2,
    Expo,
    TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
    name: "ComplianceCard",
})
export default class ComplianceCard extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    public compAnim() {
        var cmimg = document.querySelectorAll(".sq-home-compliance-area img");
        var compbox = document.querySelectorAll(".compliance-text");
        var comptext = document.querySelectorAll(".cmp-text");
        const controller1 = new ScrollMagic.Controller();
        cmimg.forEach((cimg) => {
            const cmtmln = new TimelineMax().from(cimg, 1.2, {
                yPercent: 40,
                autoAlpha: 0,
                ease: Expo.easeOut,
                clearProps: "all",
            });

            const scene1 = new ScrollMagic.Scene({
                    triggerElement: cimg,
                    reverse: false,
                    offset: -200,
                })
                .setTween(cmtmln)
                .addTo(controller1);
        });

        //  animation3
        const controller2 = new ScrollMagic.Controller();

        compbox.forEach((textbox) => {
            const tbox = new TimelineMax().from(
                textbox,
                0.6, {
                    autoAlpha: 0,
                    yPercent: 40,
                    scale: 0.5,
                    ease: Expo.easeInOut,
                    clearProps: "all",
                },
                "-=.5"
            );

            const scene2 = new ScrollMagic.Scene({
                    triggerElement: textbox,
                    reverse: false,
                    offset: -400,
                })
                .setTween(tbox)
                .addTo(controller2);
        });

        //  animation3
        const controller3 = new ScrollMagic.Controller();

        comptext.forEach((cmtext) => {
            const cmtimeline = new TimelineMax().from(
                cmtext,
                0.8, {
                    yPercent: 40,
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                    clearProps: "all",
                },
                "+=.1"
            );

            const scene3 = new ScrollMagic.Scene({
                    triggerElement: cmtext,
                    reverse: false,
                    offset: -450,
                })
                .setTween(cmtimeline)
                .addTo(controller3);
        });
    }
    public mounted() {
        if (window.matchMedia("(min-width: 1025px)").matches) {
            this.compAnim();
        }

    }
}
